import React, { useState } from 'react';

import OurStylistData from './Data/OurStylistData';
import GalleryData from './Data/GalleryData';
import ColorPallet from '../../../../../../utils/ColorPallet';

import BookingButton from '../../../Location/components/BookingButton';

function SecondSection() {
 const tabs = [
  { id: 'about', label: 'About' },
  { id: 'stylists', label: 'Our Stylists' },
  { id: 'gallery', label: 'Gallery' },
  { id: 'location', label: 'Location' },
];

  const [activeTab, setActiveTab] = useState('about');
  const [selectedLocation, setSelectedLocation] = useState('Jakarta');
  const locations = Object.keys(GalleryData);
 
  return (
    <div className="min-h-screen p-4 md:p-8">
      <div className="max-w-6xl mx-auto mb-8">

        {/* Navigation Tabs */}
        <div className="flex gap-4 mb-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`px-4 py-2 transition-colors duration-300 ${
                activeTab === tab.id
                  ? 'text-orange-900 border-b-2 font-bold border-orange-900'
                  : ColorPallet.primaryDarkBrown
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Content About */}
        <div className="mb-8">
          {activeTab === 'about' && (
            <div className="backdrop-blur-sm border border-slate-700 rounded-lg p-6" style={{ backgroundColor: ColorPallet.secondLightBrown }}>
              <h2 className="text-xl font-bold mb-4" style={{ color: ColorPallet.primaryDarkBrown }}>About Us</h2>
              <p className="text-white space-y-6">
                <span className="block mb-6">
                  はじめまして (Hajimemashite) - Selamat mengenal Papakilo Jakarta
                </span>

                <span className="block mb-6">
                  Filosofi kami berakar pada konsep 'Wa' (和) - harmoni yang menjadi inti dari budaya Jepang. Di Papakilo Jakarta, kami memaknai keindahan melalui tiga pilar fundamental:
                </span>

                <span className="block mb-6">
                  <strong>'Shibumi' (渋み) - Keanggunan yang tidak mencolok</strong>
                  <br />
                  Kami percaya bahwa keindahan sejati terletak pada kesederhanaan yang elegan. Setiap potongan dan gaya yang kami ciptakan merayakan keunikan alami Anda, bukan mengubahnya secara drastis. Seperti seni bonsai yang dengan sabar dibentuk, kami membantu menemukan dan memperindah esensi natural Anda.
                </span>

                <span className="block mb-6">
                  <strong>'Kaizen' (改善) - Penyempurnaan berkelanjutan</strong>
                  <br />
                  Setiap helai rambut yang kami sentuh adalah komitmen untuk terus belajar dan berkembang. Tim kami tidak hanya mengikuti tren, tapi memahami bahwa kesempurnaan adalah perjalanan tanpa akhir, selalu mencari cara untuk memberikan yang terbaik bagi setiap tamu.
                </span>

                <span className="block mb-6">
                  <strong>'Omotenashi' (おもてなし) - Pelayanan dari hati</strong>
                  <br />
                  Lebih dari sekadar layanan prima, kami menerapkan filosofi 'omotenashi' - seni melayani dengan tulus tanpa mengharapkan imbalan. Setiap gerakan, setiap interaksi, didasari oleh kepedulian mendalam terhadap kenyamanan dan kepuasan Anda.
                </span>

                <span className="block mb-6">
                  Di Papakilo Jakarta, kami tidak sekadar menciptakan gaya rambut - kami mengundang Anda dalam perjalanan menemukan keseimbangan antara inner beauty dan outer beauty, antara tradisi dan modernitas, antara diri Anda yang sekarang dan potensi terbaik yang bisa diwujudkan.
                </span>

                <span className="block">
                  Seperti filosofi 'Ikigai' (生き甲斐) - kami ada untuk membantu Anda menemukan kebahagiaan melalui penampilan yang mencerminkan jati diri sejati Anda.
                </span>
              </p>
            </div>
          )}

          {/* Tab Content Stylist */}
          {activeTab === 'stylists' && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {OurStylistData.map((stylist, index) => (
                <div 
                  key={index} 
                  className="bg-white/10 border border-slate-700 rounded-lg p-6 text-center 
                  hover:bg-gradient-to-r from-blue-600 to-purple-600 hover:scale-110 group transition-transform duration-300">
                  {/* Stylist Avatar */}
                  <div className="w-24 h-24 mx-auto mb-4 rounded-full bg-[#efcdbe] group-hover:bg-white flex items-center justify-center">
                    <img 
                      src={stylist.image} 
                      alt={stylist.name} 
                      className="w-full h-full object-contain rounded-full" 
                    />
                  </div>

                  {/* Stylist Information */}
                  <h3 className="text-lg font-semibold mb-2 group-hover:text-white">{stylist.name}</h3>
                  <p className="text-slate-600 mb-1 group-hover:text-white/80">{stylist.specialty}</p>
                  <p className="text-sm text-slate-800 group-hover:text-white/70">Experience: {stylist.experience}</p>
                </div>
              ))}
            </div>
          )}

          {/* Tab Content Gallery */}
          {activeTab === 'gallery' && (
            <div className="backdrop-blur-sm border border-slate-700 rounded-lg p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-bold" style={{ color: '#4A3427' }}>Gallery Jakarta</h2>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {GalleryData.map((item, index) => (
                  <div 
                    key={index} 
                    className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
                  >
                    <img 
                      src={item.image}
                      alt={item.title}
                      className="w-full h-60 object-cover rounded-lg transition-transform duration-300 group-hover:scale-105"
                    />
                    {/* <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                      <h3 className="font-semibold text-lg mb-1">{item.title}</h3>
                      <p className="text-sm text-gray-200">{item.category}</p>
                    </div> */}
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'location' && (
            <div className="backdrop-blur-sm border border-slate-700 rounded-lg p-6 bg-white">
              <h2 className="text-xl font-bold mb-0" style={{ color: ColorPallet.primaryDarkBrown }}>Our Locations</h2>
              
              {/* Location Selector */}
              <div className="flex flex-wrap gap-2 mb-6">
                {locations.map((loc) => (
                  <button
                    key={loc}
                    className={`px-4 py-0 rounded-lg transition-colors duration-300 ${
                      selectedLocation === loc
                        ? 'bg-orange-900 text-white'
                        : 'bg-white/20 text-white hover:bg-white/30'
                    }`}
                    onClick={() => setSelectedLocation(loc)}
                  >
                    {loc}
                  </button>
                ))}
              </div>

              {/* Location Details */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Map */}
                <div className="rounded-lg overflow-hidden h-full border border-slate-600">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.9747123943266!2d106.73098297413!3d-6.13409996013773!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e6a1daa57288591%3A0xeaaadc216ae9bbce!2sPapakilo%20Barbershop%20landed%20in%20Japan!5e0!3m2!1sid!2sid!4v1739426862957!5m2!1sid!2sid"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>

                {/* Contact Information */}
                <div className="text-slate-800 space-y-6">
                  <div>
                    <h3 className="text-lg font-semibold mb-2">Papakilo Jakarta (Landed In Japan)</h3>
                    <p className="text-slate-400">
                      The City Resort Residence Rukan Malibu Bl. H, Jl. Boulevard Raya No. 2-3, Cengkareng Tim., Kecamatan Cengkareng, Kota Jakarta Barat, Daerah Khusus Ibukota Jakarta 11730
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold mb-2">Opening Hours</h3>
                    <div className="grid grid-cols-2 text-slate-400">
                      <div>
                        <p>Senin - Minggu :</p>
                      </div>
                      <div>
                        <p>10:00 - 22:00</p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold mb-2">Contact</h3>
                    <p className="text-slate-400">Phone : +62 852-8241-1391</p>
                    <p className="text-slate-400">Email : papakilobarbershop@gmail.com</p>
                    <p className="text-slate-400">Instagram : @papakilo.hairstudio</p>

                  </div>

                  <div className="p-4 bg-gradient-to-r from-purple-600 to-blue-500 w-60 rounded-full">
                    <BookingButton />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SecondSection